import React from 'react'

import PropTypes from 'prop-types'
import { NotificationStack } from 'react-notification'
import { connect } from 'react-redux'

import { actions as snackbarActions } from 'store/snackbar'

export class Snackbar extends React.Component {
  static propTypes = {
    notifications: PropTypes.array.isRequired,
    dismissNotification: PropTypes.func.isRequired,
  }
  render() {
    return (
      <div className="snackbar-comp">
        <NotificationStack
          notifications={this.props.notifications}
          onDismiss={(notification) => this.props.dismissNotification(notification)}
          barStyleFactory={(idx, barStyle) => {
            return {
              ...barStyle,
              zIndex: 1030,
              fontSize: '13px',
              maxWidth: '95%',
              marginBottom: '50px',
            }
          }}
          actionStyleFactory={(idx, styles) => {
            return {
              ...styles,
              fontSize: '11px',
              color: '#ff603e',
            }
          }}
          onClick={(notification, deactivate) => {
            deactivate()
            setTimeout(() => {
              this.props.dismissNotification(notification)
            }, 300)
          }}
        />
      </div>
    )
  }
}

export default connect(
  (state) => ({
    notifications: state.snackbar.queue,
  }),
  {
    dismissNotification: snackbarActions.dismissSnackbarItem,
  },
)(Snackbar)
